import database from "../Assets/skills/database.png";
import developer from "../Assets/skills/developer.png";

function  Skills() {
  return (
    <div  id="skills" className="container">
      <h4>
        My Skills<span>$</span>
      </h4>
<div className="all-skills-container">
      <div className="container all-skills">
        <span>
          <img className="skills-icon" src={developer} alt="developer" />
        </span>
        <div className="skills">
          <ul>
            <li>JavaScript</li>
            <li>React</li>
            <li>ReactNative</li>
            <li>Vue</li>
            <li>JS Testing</li>
          </ul>
          <ul>
            <li>HTML</li>
            <li>CSS(3)</li>
            <li>SCSS</li>
            <li>Bootstrap</li>
            <li>Tailwind</li>
            <li>NodeJS</li>
          </ul>
          <ul>
            <li>Python</li>
            <li>Java</li>
            <li>PHP</li>
            <li>Laravel</li>
            <li>ExpressJS</li>
          </ul>
        </div>
      </div>
      <div className="container all-skills">
        <span>
          <img className="skills-icon" src={database} alt="database" />
        </span>
        <div className="skills">
          <ul>
            <li>MongoDB</li>
            <li>MySQL</li>
            <li>SQLite</li>
          </ul>
          <ul></ul>
        </div>
        </div>
      </div>
    </div>
  );
}

export default Skills;
